import {
  trackFormFieldEntered,
  trackFormSubmitted,
  trackFormSubmitHovered,
  trackPromoCodeApplied,
  trackPromoCodeDenied,
  trackPromoCodeEntered,
  trackPromoCodeRemoved
} from 'client/javascript/analytics';
import { FORM_PAGE_ELEMENT } from 'client/javascript/lead_form_analytics';

/**
 * Form Tracking for lead form field entered
 * @param element
 * @param title
 * @param pageType
 */
export function trackFieldEntered(element, title, pageType) {
  const props = {
    track_label: 'Form field entered',
    form_name: title,
    form_field_name: element.attributes.name.value,
    form_field_type: element.type,
    form_field_value: element.options ? element.options[element.selectedIndex].text : element.value, // if it's marketSelect field we take its text content instead of market UUID value
    page_element: FORM_PAGE_ELEMENT,
    page_type: pageType
  };
  trackFormFieldEntered(props);
}

/**
 * Form Tracking for form submit
 * @param title
 * @param pageType
 */
export function trackFormSubmit(title, pageType) {
  const props = {
    track_label: 'Form submitted',
    form_name: title,
    page_element: FORM_PAGE_ELEMENT,
    page_type: pageType
  };
  trackFormSubmitted(props);
}

/**
 * Form Tracking for hover over form submit button
 * @param title
 * @param pageType
 */
export function trackFormSubmitHover(title, pageType) {
  const props = {
    track_label: 'Form submit hovered',
    form_name: title,
    page_element: FORM_PAGE_ELEMENT,
    page_type: pageType
  };
  trackFormSubmitHovered(props);
}

/**
 * Form Tracking Submit interaction Lead form STEP 1
 * @param formValues
 * @param dataPackage
 * @param pageType
 */
export function trackInteractionForm(formValues, dataPackage, pageType) {
  const props = {
    track_label: 'Lead Form Submitted',
    form_name: dataPackage.mobileHeadLine,
    contact_name: formValues.contact_name,
    email: formValues.email,
    phone: formValues.phone,
    company_size: dataPackage.capacity,
    move_in_date: formValues.move_in_date,
    experience: dataPackage.stepOneExperience,
    page_element: dataPackage.url,
    page_type: pageType
  };
  trackFormSubmitted(props);
}

/**
 * Form Tracking Promo code interaction order total
 * @param value
 * @param pageType
 */
export function trackValueEntered(value, pageType) {
  const props = {
    promo_code: value,
    page_type: pageType
  };
  trackPromoCodeEntered(props);
}

/**
 * Form Tracking Promo code Submit order details
 * @param promoCode
 * @param discountData
 * @param pageType
 */
export function trackPromoCodeSubmit(promoCode, discountData, pageType) {
  const props = {
    promo_code: promoCode,
    discount: discountData,
    page_type: pageType
  };
  trackPromoCodeApplied(props);
}

/**
 * Form Tracking Promo code Denied order details
 * @param promoCode
 * @param pageType
 */
export function trackPromoCodeSubmitDenied(promoCode, pageType) {
  const props = {
    promo_code: promoCode,
    page_type: pageType
  };
  trackPromoCodeDenied(props);
}

/**
 * Form Tracking Promo code Removed
 * @param promoCode
 * @param discountData
 * @param pageType
 */
export function trackClearPromoCode(promoCode, discountData, pageType) {
  const props = {
    promo_code: promoCode,
    discount: discountData,
    page_type: pageType
  };
  trackPromoCodeRemoved(props);
}
